(function (ws) {
    'use strict';

    ws.views.accountquoteTable = ws.views.simpleTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'search_quote',
        GTM_EVENT_DETAIL_ACTION: 'quote_details',

        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click [data-event="closeTooltip"]': 'close',
            'click [data-event="openTooltip"]': 'open',
            'click .comp-tooltip-label': 'open',
            'mouseover .comp-tooltip-label': 'open',
            'mouseout .comp-tooltip-label': 'close',
            'touchstart .comp-tooltip-label': 'open',
            'touchend .comp-tooltip-label': 'close',
            'change select#tbl-simple-page-size': 'searchFilter',
            'click ul.pagination li a': 'paginate',
            'click .quote-detail-gaEvent': 'quoteActivityCapture',
            'change input#tbl-simple-start-due-date': 'validateDueDate',
            'change input#tbl-simple-end-due-date': 'validateDueDate',
            'keydown input#tbl-simple-end-due-date': 'validateDueDate',
            'keydown input#tbl-simple-start-due-date': 'validateDueDate',
            'focusout input#tbl-simple-end-due-date': 'validateDueDate',
            'focusout input#tbl-simple-start-due-date': 'validateDueDate',
            'change input#tbl-simple-start-contract-due-date': 'validateContractDueDate',
            'change input#tbl-simple-end-contract-due-date': 'validateContractDueDate',
            'keydown input#tbl-simple-end-contract-due-date': 'validateContractDueDate',
            'keydown input#tbl-simple-start-contract-due-date': 'validateContractDueDate',
            'focusout input#tbl-simple-end-contract-due-date': 'validateContractDueDate',
            'focusout input#tbl-simple-start-contract-due-date': 'validateContractDueDate',
            'click .rnq-table-checkbox-selectAll': 'toggleAllCheckboxes',
            'click .rnq-table-checkbox': 'enableDownlodButton',
            'click .export-multiOrder': 'downloadMultipleOrder'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            var westconApi = globals.path.api.westcon;

            this.disableFutureDate = false;
            this.$table = $('#rnq-table');
            this.paginateUrl = westconApi.accountQuoteTablePaginateUrl;
            this.searchUrl = westconApi.accountQuoteTableSearchUrl;
            this.rowTemplate = $('#rnq-table-row');
            this.tooltipModal = $('.comp-tooltip-modal');
            this.compTooltipContent = $('.comp-tooltip-content');
            ws.views.simpleTable.prototype.initialize.call(this);
            this.$startDueDateInput = this.$('#tbl-simple-start-due-date');
            this.$endDueDateInput = this.$('#tbl-simple-end-due-date');
            this.$startContractDueDateInput = this.$('#tbl-simple-start-contract-due-date');
            this.$endContractDueDateInput = this.$('#tbl-simple-end-contract-due-date');
            this.eventAgg.on('removeTooltipView', this.close.bind(this));
            this.$tooltips = $('.comp-tooltip-content');
            this.$dateDueError = this.$('.date-error-due');
            this.$validDueDateError = this.$('.valid-date-due-error');
            this.$dateContractDueError = this.$('.date-contract-error-due');
            this.$validContractDueDateError = this.$('.valid-contract-date-due-error');
            this.multiViewEnabled = this.$('#multiViewEnabled').val();
            this.showQuoteTransferedUser = this.$('#showQuoteTransferedUser').val();
            this.enableQuotesExport = this.$('#enableQuotesExport').val();
            this.$selectAllCheckbox = this.$('.rnq-table-checkbox-selectAll');

            if (this.multiViewEnabled == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.$('.rnq-table-checkbox').prop('checked', false);
            }

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table',
                placeholderOption: function () { return undefined; }
            });

            $(this.el).off('change', 'select#tbl-simple-am');
            $(this.el).off('change', 'select#tbl-simple-select');

            this.initializeDueRangePikaday();
            this.initializeContractDueRangePikaday();

            this.searchCategory = 'quote';
            let url = new URL(window.location.href);
            if (url.searchParams.get('renewal')) {
                this.$('#tbl-simple-source').val('RENEWAL').trigger('change');
            }

            if (url.searchParams.get('quote')) {
                this.$('#tbl-simple-source').val('QUOTE').trigger('change');
            }

            this.enableDownlodButton();
            this.searchFilter();
            setTimeout(function () {
                var ignoreClickOnMeElement = document.getElementById('headerOptions');
                var ignoreClickOnMe = document.getElementById('checkboxesHeader');

                $('#headerOptions').select2('destroy');
                $('.overSelect').on('click', function(event) {
                    $('.checkboxesHeader').toggle();
                    event.stopPropagation();
                });

                if (ignoreClickOnMeElement && ignoreClickOnMe) {
                    $(document).on('click', function(event) {
                        var isClickInsideElement = ignoreClickOnMeElement.contains(event.target);
                        var isClickInside = ignoreClickOnMe.contains(event.target);
                        if (!isClickInsideElement && !isClickInside) {
                            $('#checkboxesHeader').css('display', 'none');
                        }
                    });
                }
            }, 1000);
        },

        /**
         * Check select all checkbox and check/uncheck
         */
        checkSelectAllCheckbox () {
            const totalCheckboxes = this.$('.rnq-table-checkbox:enabled').length;
            const selectedCheckboxes = $('.rnq-table-checkbox:checked').length;
            if (selectedCheckboxes == 0) {
                this.$selectAllCheckbox.prop('checked', false);
            } else {
                this.$selectAllCheckbox.prop('checked', totalCheckboxes === selectedCheckboxes);
            }
        },

        /**
         * Change the state of all the checkboxes in the Order Listing table table.
         * @param {Object} ev
         */
        toggleAllCheckboxes: function (ev) {
            var $checkboxes = this.$('.rnq-table-checkbox');
            var $checkboxAll = this.$('.rnq-table-checkbox-selectAll');
            _.each($checkboxes, function(checkbox) {
                if (!$(checkbox).is(':disabled')) {
                    $(checkbox).prop('checked', $checkboxAll.is(':checked'));
                }
            });

            this.enableDownlodButton();
        },

        /**
         *  Enable the download button and disable Download Button
         */
        enableDownlodButton: function () {
            var $checkboxes = this.$('.rnq-table-checkbox');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if (!$(checkbox).is(':disabled')) {
                    if ($(checkbox).is(':checked')) {
                        $('.export-multiOrder').attr('disabled', false);
                        flag = 0;
                    } else {
                        $('.rnq-table-checkbox-selectAll').prop('checked', false);
                    }
                }
            });

            if (flag === 1) {
                $('.export-multiOrder').attr('disabled', true);
            }

            this.checkSelectAllCheckbox();
        },

        /**
         * Downloading the multiple orders excel functionality
         */
        downloadMultipleOrder: function () {
            globals.disableApp();
            let downloadText = $('.downloadAfterText').html();
            var $checkboxes = this.$('.rnq-table-checkbox');
            var quoteNumberList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true) {
                    quoteNumberList.push($(checkbox).data('attr'));
                }
            });

            const CSRFToken = $('#CSRFToken').val();
            const urlExportOrderList = globals.path.api.westcon.exportQuotesList + '?CSRFToken=' + CSRFToken;
            const data = {
                quoteNumberList: quoteNumberList
            };

            // DOWNLOADING EXCEL FILE FROM THE BLOB.
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        navigator.msSaveBlob(xhttp.response, `${downloadText}.zip`);
                    } else {
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);

                        // Give filename you wish to download
                        a.download = `${downloadText}.zip`;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }

                    globals.enableApp();
                }
            };

            xhttp.open('POST', urlExportOrderList);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(data));
        },

        /**
         * Initialize pikaday
         */
        initializeDueRangePikaday: function () {
            var _startDueDate;
            var _endDueDate;
            var _this = this;

            this.startDuePicker = this.$startDueDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this._startDueDate = this.getDate();
                    _this.pikadayUpdateStartDate(_this.startDuePicker, _this.endDuePicker, _this._startDueDate);
                    _this.$startDueDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateDueDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            this.endDuePicker = this.$endDueDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this.endDueDate = this.getDate();
                    _this.pikadayUpdateEndDate(_this.startDuePicker, _this.endDuePicker, _this.endDueDate);
                    _this.$endDueDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateDueDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            if (this.startDuePicker.length > 0) {
                _startDueDate = this.startDuePicker.data('pikaday').getDate();
            }

            if (this.startDuePicker.length > 0) {
                _endDueDate = this.endDuePicker.data('pikaday').getDate();
            }

            if (_startDueDate) {
                this._startDueDate = _startDueDate;
                this.pikadayUpdateStartDate(this.startDuePicker, this.endDuePicker, this._startDueDate);
            }

            if (_endDueDate) {
                this.endDueDate = _endDueDate;
                this.pikadayUpdateEndDate(this.startDuePicker, this.endDuePicker, this.endDueDate);
            }
        },

        initializeContractDueRangePikaday: function () {
            var _startContractDueDate;
            var _endContractDueDate;
            var _this = this;

            this.startContractDuePicker = this.$startContractDueDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this._startContractDueDate = this.getDate();
                    _this.pikadayUpdateStartDate(_this.startContractDuePicker, _this.endContractDuePicker, _this._startContractDueDate);
                    _this.$startContractDueDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateContractDueDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            this.endContractDuePicker = this.$endContractDueDateImg.pikaday({

                /**
                 * onSelect callback
                 */
                onSelect: function () {
                    _this.endContractDueDate = this.getDate();
                    _this.pikadayUpdateEndDate(_this.startContractDuePicker, _this.endContractDuePicker, _this.endContractDueDate);
                    _this.$endContractDueDateInput.val(this.getMoment().format(dateFormat));
                    _this.validateContractDueDate('pikaday');
                },

                maxDate: this.disableFutureDate ? new Date() : null
            });

            if (this.startContractDuePicker.length > 0) {
                _startContractDueDate = this.startContractDuePicker.data('pikaday').getDate();
            }

            if (this.startContractDuePicker.length > 0) {
                _endContractDueDate = this.endContractDuePicker.data('pikaday').getDate();
            }

            if (_startContractDueDate) {
                this._startContractDueDate = _startContractDueDate;
                this.pikadayUpdateStartDate(this.startContractDuePicker, this.endContractDuePicker, this._startContractDueDate);
            }

            if (_endContractDueDate) {
                this.endContractDueDate = _endContractDueDate;
                this.pikadayUpdateEndDate(this.startContractDuePicker, this.endContractDuePicker, this.endContractDueDate);
            }
        },

        /**
         * Validate date but without make api call to search
         */
        validateDate (e) {
            ws.views.simpleTable.prototype.validateDate.call(this, e, false);
        },

        /**
         * Check date fields
         */
        validateDueDate: function (e) {
            // if pressing enter key, prevent refresh (since some tables are forms)
            //e may not be defined if date changed happens from pikaday

            if (e && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
            }

            var beginningDueDate = this.$startDueDateInput.val();
            var endDueDate = this.$endDueDateInput.val();
            var beginDueDateValid = globals.validateDate(beginningDueDate);
            var endDueDateValid = globals.validateDate(endDueDate);

            //remove error classes
            this.$startDueDateInput.removeClass('error');
            this.$endDueDateInput.removeClass('error');
            this.$dateDueError.hide();
            this.$validDueDateError.hide();

            //show start date error
            if (beginDueDateValid === false) {
                this.$startDueDateInput.addClass('error');
                this.$dateDueError.show();
            }

            //show end date error
            if (endDueDateValid === false) {
                this.$endDueDateInput.addClass('error');
                this.$dateDueError.show();
            }

            //check for start date is less than end date
            var validCheck = '';
            if (endDueDateValid && beginDueDateValid) {
                validCheck = globals.compareDates(beginningDueDate, endDueDate);
                if (!validCheck) {
                    this.$validDueDateError.show();
                }
            }
        },

        validateContractDueDate: function (e) {
            // if pressing enter key, prevent refresh (since some tables are forms)
            //e may not be defined if date changed happens from pikaday

            if (e && (e.keyCode === 13 || e.which === 13)) {
                e.preventDefault();
            }

            var beginningDueDate = this.$startContractDueDateInput.val();
            var endDueDate = this.$endContractDueDateInput.val();
            var beginDueDateValid = globals.validateDate(beginningDueDate);
            var endDueDateValid = globals.validateDate(endDueDate);

            //remove error classes
            this.$startContractDueDateInput.removeClass('error');
            this.$endContractDueDateInput.removeClass('error');
            this.$dateContractDueError.hide();
            this.$validContractDueDateError.hide();

            //show start date error
            if (beginDueDateValid === false) {
                this.$startContractDueDateInput.addClass('error');
                this.$dateContractDueError.show();
            }

            //show end date error
            if (endDueDateValid === false) {
                this.$endContractDueDateInput.addClass('error');
                this.$dateContractDueError.show();
            }

            //check for start date is less than end date
            var validCheck = '';
            if (endDueDateValid && beginDueDateValid) {
                validCheck = globals.compareDates(beginningDueDate, endDueDate);
                if (!validCheck) {
                    this.$validContractDueDateError.show();
                }
            }
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();
            this.model.save().done(function (data) {
                this.$('.error-message-merge').addClass('hide').hide();
                if (data.error) {
                    this.$('.error-message-merge').removeClass('hide').show();
                }

                this.$tableSpinner.hide();
                this.disabledDelaySpinner();
                this.renderRows(data.data);
                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                this.$pagination.addClass('search');

                // this.$clearFilterButton.toggle(this.showClearFilterButton);
                // if (this.showClearFilterButton) {
                //     this.$('.message-link').hide();
                // }

                if (data.paginationData.numberOfPages > 1) {
                    $('.export-multiOrder').css('margin-right', '8%');
                } else {
                    $('.export-multiOrder').css('margin-right', '8%');
                }

                this.toggleApplySearchBtn(true);
            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            if ($('#enableQuotesExport').val() == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.enableDownlodButton();
            }

            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = _this.multiViewEnabled;
                row.showQuoteTransferedUser = _this.showQuoteTransferedUser;
                row.enableQuotesExport = _this.enableQuotesExport;

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Validate price but without make api call to search
         * @param {Object} e - Event object
         */
        validatePrice: function (e) {
            ws.views.simpleTable.prototype.validatePrice.call(this, e, false);
        },

        /**
         * Attach click events to all revision anchor triggers
         * @param {Object} row - Table row element
         */
        rowCallback: function (row) {
            $(row).find('[data-quote-code]').on('click', function (ev) {
                ev.preventDefault();

                this.eventAgg.trigger('openRevisionModal');

                new ws.views.quoteRevisionsTable({
                    quoteCode: $(ev.currentTarget).data('quote-code')
                });
            }.bind(this));
        },

        /**
         * Opens the tooltip
         */
        open: function (ev) {

            this.closeAll();
            this.checkTooltipPosition();

            // show this tooltip
            $(ev.currentTarget).parent().find('.comp-tooltip-content').show();
        },

        /**
         * Check tooltip position. If it's near of the right border we have to show it to left position
         */
        checkTooltipPosition () {
            if (this.tooltipModal.offset().left > 1300) {
                this.compTooltipContent.addClass('show-left');
            } else {
                this.compTooltipContent.removeClass('show-left');
            }
        },

        /**
         * Close all tooltips
         */
        closeAll: function () {
            this.$tooltips.hide();
        },

        /**
         * Closes the tooltip and destroys the view
         */
        close: function (ev) {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                $(ev.currentTarget).parent().find('.comp-tooltip-content').hide();
            }
        },

        // Send tracking data to Google Analytics
        quoteActivityCapture () {
            localStorage.setItem('quoteActivity', '1');
        }

    });
})(westcon);
